import shared from "emun.shopping/shopping.config.es6"; //get shared
import AutoQueryConfig from "servicestack/auto-query/auto-query.config";
import resolve from "ioc/resolve";
import $pageConfig from "webutils/services/page-config";

const last365 = () => moment().subtract(1, "year").format("YYYY-MM-DD");
export const IS_CMS = (ENV_TAGS || []).indexOf("Cms") >= 0;
export const IS_CRM = (ENV_TAGS || []).indexOf("Crm") >= 0;

export default Object.assign(shared, {
  fields:
    "Id,ManufacturerNumber,ShortDescription,Price,WholesalePrice,ListPrice,Category,OptionGroup,MinimumOrderQty,PurchaseIncrement,AvailableQty,ProductTags,isNew,ItemType,IsKitEditable,VendorID,ShipOn",
  filters: [
    {
      text: "Search",
      operation: "",
      title: "Search Products",
      panelType: "none",
      hidden: IS_CMS,
    },
    { tag: "Vendor", collapsed: false, title: "Brands" },
    { tag: "Badges", collapsed: true, title: "Highlights" },
    { tag: "Category", collapsed: true, hidden: true, title: "Categories" },
    {
      tag: "SubCategory",
      collapsed: true,
      hidden: true,
      title: "Sub-categories"
    },
    {
      tag: "Web Collection 1",
      collapsed: true,
      title: "Collections"
    },
    {
      tag: "Web Collection 2",
      collapsed: true,
      title: "Sub-collections",
      hidden: false
    },
    {
      tag: "Web Collection 3",
      collapsed: true,
      title: "Sub-collections 2",
      hidden: false
    },
    { text: "ListId", operation: "", collapsed: true, hidden: (s) => !s.isAdministrator() },

    { tag: "Catalog", collapsed: true, hidden: (s) => !s.isAdministrator() },
    {
      tag: "Web Category 1",
      collapsed: true,
      title: "Category",
      hidden: false
    },
    {
      tag: "Web Category 2",
      collapsed: true,
      title: "Sub-category 1",
      hidden: false
    },
    {
      tag: "Web Category 3",
      collapsed: true,
      title: "Sub-category 2",
      hidden: false
    },
    {
      tag: "Web Category 4",
      collapsed: true,
      title: "Sub-category 3",
      hidden: false
    },
    {
      tag: "Color",
      collapsed: true,
      hidden: true
    },
    {
      tag: "Products",
      collapsed: true,
      hidden: true
    },
    {
      tag: "Fragrance",
      collapsed: true,
      hidden: true
    },
    {
      tag: "School Name",
      collapsed: true,
      hidden: true
    },
    { tag: "$MultiView", hidden: true, value: ["Yes"] },
    { text: "utm_source", operation: "", hidden: true, authorize: (s) => IS_CMS },
    { text: "utm_medium", operation: "", hidden: true, authorize: (s) => IS_CMS },
    { text: "utm_campaign", operation: "", hidden: true, authorize: (s) => IS_CMS },
    { text: "spMailingID", operation: "", hidden: true, authorize: (s) => IS_CMS },
    { text: "spUserID", operation: "", hidden: true, authorize: (s) => IS_CMS },
    { text: "spJobID", operation: "", hidden: true, authorize: (s) => IS_CMS },
    { text: "spReportId", operation: "", hidden: true, authorize: (s) => IS_CMS },
    {
      radio: "MutEx",
      title: "Purchase History",
      collapsed: true,
      hidden: (s) => !s.isRetailerOrAbove() && IS_CMS,
      options: [
        {
          fieldName: "PurchasedAfter",
          label: "Purchased last 365",
          value: last365,
        },
        {
          fieldName: "ShippedAfter",
          label: "Shipped last 365",
          value: last365,
        },
        {
          fieldName: "OnOrder",
          label: "On Current Order",
          value: () => resolve("$cart").id,
        },
      ],
    },
    {
      number: "WholesalePrice",
      title: "Price",
      collapsed: true,
      min: 0,
      max: 2000,
      step: 0.01,
      hidden: (s) => s.isAuthenticated || s.businessModel === "Retail" || IS_CMS,
    }
  ],
  afterProcessed(args, pq) {
    const categoryParams = pq.filters
      .filter((f) => f.tag === "Web Category 1")
      .reduce((a, f) => a.concat(f.getParams()), []);
    pq.filters
      .filter((f) => f.tag === "Web Category 2")
      .forEach((sf) => {
        sf.hidden = categoryParams.length === 0;
      });
    pq.filters
      .filter((f) => f.tag === "Web Category 3")
      .forEach((sf) => {
        sf.hidden = categoryParams.length === 0;
      });
    pq.filters
      .filter((f) => f.tag === "Web Category 4")
      .forEach((sf) => {
        sf.hidden = categoryParams.length === 0;
      });

    const colectionParams = pq.filters
      .filter((f) => f.tag === "Web Collection 1")
      .reduce((a, f) => a.concat(f.getParams()), []);
    pq.filters
      .filter((f) => f.tag === "Web Collection 2")
      .forEach((sf) => {
        sf.hidden = colectionParams.length === 0;
      });
    pq.filters
      .filter((f) => f.tag === "Web Collection 3")
      .forEach((sf) => {
        sf.hidden = colectionParams.length === 0;
      });
  },
  // fundboxCheckout: {
  //   key: "pk_test_dce5ddb3-61d9-4354-a1ec-f97b262800f3",
  // },
  hideEmptyGroupings: AutoQueryConfig.hideEmptyGroupings,
  hideGroupingCounts: AutoQueryConfig.hideGroupingCounts,
  panelType: "none",
  requireCVV: false,
  maxPanelHeight: "300px",
  relatedItemsTagKind: () => IS_CRM ? "" : "Category",
  othersBoughtTagKind: "",
  shoppingSearchTop: true,
  hideLeftNav: () => IS_CRM && $pageConfig.width<1100,
  showOutline: true,
  hideAcceptTerms: true,
  showAcceptTerms: false,
  requireAcceptTerms: false,
  notifyItemOnOpenOrder: false,
  multiCart: IS_CMS ? true : false,
  showNotRequireCVV: false,
  writeOrderDataAcoustic: true,
  useFaceBookPixel: true,
  disableCustomerAlsoBought: IS_CRM,
  disableAccessoryProducts: true,
  sortOptions: {
    "-CreatedOn,Id": "Newest to Oldest",
    Id: "Item Number",
    WholesalePrice: "Price: Low to High",
    "-WholesalePrice": "Price: High to Low",
    ShortDescription: "Name: A to Z",
    "-ShortDescription": "Name: Z to A",
  },
  orderBy: "-CreatedOn,Id",
});
